import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoCompareProduct from 'eco-design/sections/eco-compare-product';
import styles from './index.module.scss';
import EfSection from '@elem/ui/ef-section';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { ENUM_ECO_CART_EVENT, ItfEcoCartItem } from 'eco-design-components/elements/eco-cart/type.d';
import gtm from 'eco-design-reliance/gtm';

const JN = ({ cards }: any) => {
    const { t } = useLang('delta3series');
    const lBtnClick = (index: number) => {
        const { price, compareAtPrice, img, variantImg, inventoryPolicy, inventoryQuantity, productTitle, skuTitle, productId, variantId } = cards?.[index];
        EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_ADD, [
            {
                price,
                compareAtPrice,
                img,
                variantImg,
                inventoryPolicy,
                inventoryQuantity,
                productTitle,
                skuTitle,
                productId,
                variantId,
                quantity: 1,
            } as ItfEcoCartItem,
        ]);
        gtm.push({
            event: 'uaEvent',
            event_name: 'bundle_add_to_cart',
            product_name: cards?.[index]?.name || cards?.[index]?.title || productTitle || skuTitle,
            list_name: t('N_title') || 'none',
            price,
            tag: 'none',
            quantity: 1,
            button_name: t('P_btn'),
        });
    };
    const items = [
        {
            subItems: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1741059206784/US%201.png',
                    title: cards?.[0].title,
                    lHref: '',
                    lChildren: t('P_btn'),
                    lBtnClick: () => lBtnClick(0),
                    rHref: cards[0]?.link_more || 'https://ecoflow-japan.myshopify.com/cart/44597213003937:1?channel=buy_button',
                    rChildren: t('N_btn_text'),
                    rDataLayer: {
                        event: 'uaEvent',
                        event_name: 'checkout',
                        button_name: `${t('N_btn_text')}_${cards?.[0].title}`,
                    },
                    specItems: [
                        {
                            title: t('N_item1_title1'),
                            desc: t('N_item_decs1'),
                        },
                        {
                            title: t('N_item1_title2'),
                            desc: t('N_item_decs2'),
                        },
                        {
                            title: t('N_item1_title3'),
                            desc: t('N_item_decs3'),
                        },
                        {
                            title: t('N_item1_title4'),
                            desc: t('N_item_decs4'),
                        },
                        {
                            title: t('N_item1_title5'),
                            desc: t('N_item_decs5'),
                        },
                        {
                            title: t('N_item1_title6'),
                            desc: t('N_item_decs6'),
                        },
                        {
                            title: t('N_item1_title7'),
                            desc: t('N_item_decs7'),
                        },
                        {
                            title: t('N_item1_title8'),
                            desc: t('N_item_decs8'),
                        },
                        {
                            title: t('N_item1_title9'),
                            desc: t('N_item_decs9'),
                        },
                        {
                            title: t('N_item1_title10'),
                            desc: t('N_item_decs10'),
                        },
                        {
                            title: t('N_item1_title11'),
                            desc: t('N_item_decs11'),
                        },
                        {
                            title: t('N_item1_title12'),
                            desc: t('N_item_decs12'),
                        },
                        {
                            title: t('N_item1_title13'),
                            desc: t('N_item_decs13'),
                        },
                    ],
                },
            ],
        },
        {
            subItems: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1741673531812/Frame%201000009020.jpg',
                    title: cards?.[1].title,
                    lHref: '',
                    lChildren: t('P_btn'),
                    lBtnClick: () => lBtnClick(1),
                    rHref: cards[1]?.link_more || 'https://ecoflow-japan.myshopify.com/cart/51641953354095:1?channel=buy_button',
                    rChildren: t('N_btn_text'),
                    rDataLayer: {
                        event: 'uaEvent',
                        event_name: 'checkout',
                        button_name: `${t('N_btn_text')}_${cards?.[1].title}`,
                    },
                    specItems: [
                        {
                            title: t('N_item2_title1'),
                            desc: t('N_item_decs1'),
                        },
                        {
                            title: t('N_item2_title2'),
                            desc: t('N_item_decs2'),
                        },
                        {
                            title: t('N_item2_title3'),
                            desc: t('N_item_decs3'),
                        },
                        {
                            title: t('N_item2_title4'),
                            desc: t('N_item_decs4'),
                        },
                        {
                            title: t('N_item2_title5'),
                            desc: t('N_item_decs5'),
                        },
                        {
                            title: t('N_item2_title6'),
                            desc: t('N_item_decs6'),
                        },
                        {
                            title: t('N_item2_title7'),
                            desc: t('N_item_decs7'),
                        },
                        {
                            title: t('N_item2_title8'),
                            desc: t('N_item_decs8'),
                        },
                        {
                            title: t('N_item2_title9'),
                            desc: t('N_item_decs9'),
                        },

                        {
                            title: t('N_item2_title10'),
                            desc: t('N_item_decs10'),
                        },
                        {
                            title: t('N_item2_title11'),
                            desc: t('N_item_decs11'),
                        },
                        {
                            title: t('N_item2_title12'),
                            desc: t('N_item_decs12'),
                        },
                        {
                            title: t('N_item2_title13'),
                            desc: t('N_item_decs13'),
                        },
                    ],
                },
            ],
        },
        {
            subItems: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1741059206570/EU%2BUK.png',
                    title: cards?.[2].title,
                    lHref: '',
                    lChildren: t('P_btn'),
                    lBtnClick: () => lBtnClick(2),
                    rHref: cards[2]?.link_more || 'https://ecoflow-japan.myshopify.com/cart/51809553744239:1?channel=buy_button',
                    rChildren: t('N_btn_text'),
                    rDataLayer: {
                        event: 'uaEvent',
                        event_name: 'checkout',
                        button_name: `${t('N_btn_text')}_${cards?.[2].title}`,
                    },
                    specItems: [
                        {
                            title: t('N_item3_title1'),
                            desc: t('N_item_decs1'),
                        },
                        {
                            title: t('N_item3_title2'),
                            desc: t('N_item_decs2'),
                        },
                        {
                            title: t('N_item3_title3'),
                            desc: t('N_item_decs3'),
                        },
                        {
                            title: t('N_item3_title4'),
                            desc: t('N_item_decs4'),
                        },
                        {
                            title: t('N_item3_title5'),
                            desc: t('N_item_decs5'),
                        },
                        {
                            title: t('N_item3_title6'),
                            desc: t('N_item_decs6'),
                        },
                        {
                            title: t('N_item3_title7'),
                            desc: t('N_item_decs7'),
                        },
                        {
                            title: t('N_item3_title8'),
                            desc: t('N_item_decs8'),
                        },
                        {
                            title: t('N_item3_title9'),
                            desc: t('N_item_decs9'),
                        },

                        {
                            title: t('N_item3_title10'),
                            desc: t('N_item_decs10'),
                        },
                        {
                            title: t('N_item3_title11'),
                            desc: t('N_item_decs11'),
                        },
                        {
                            title: t('N_item3_title12'),
                            desc: t('N_item_decs12'),
                        },
                        {
                            title: t('N_item3_title13'),
                            desc: t('N_item_decs13'),
                        },
                    ],
                },
            ],
        },
    ];

    return (
        <div className={styles.comp} id="d3-N">
            <EcoSpace />
            <EfSection title={t('N_title')} />
            <EcoSpaceSmall />
            <EcoCompareProduct items={items} />
        </div>
    );
};

export default JN;
